import api from "./api";

/**
 * Nahraje doklad (jedna nebo víc stran) a počká, až ho AI přečte.
 * Vrací id dokladu. `stav(text)` dostává průběžné hlášky pro uživatele.
 * Stejný postup používá stránka Doklady i skener v horní liště na telefonu.
 */
export async function nahratDoklad(files, stav = () => {}) {
  stav(files.length > 1 ? `🤖 Nahrávám doklad (${files.length} strany)…` : "🤖 Nahrávám doklad…");
  const fd = new FormData();
  files.forEach((f) => fd.append("file", f));
  const { data: up } = await api.post("/api/doklady/upload", fd, { headers: { "Content-Type": undefined } });
  stav("🤖 Čtu doklad…");
  for (let i = 0; i < 120; i++) {
    await new Promise((r) => setTimeout(r, 2000));
    const { data: job } = await api.get(`/api/doklady/ocr-jobs/${up.job_id}`);
    if (job.status === "done") return up.faktura_id;
    if (job.status === "error") throw new Error(job.detail || "Doklad se nepodařilo přečíst.");
  }
  throw new Error("Čtení dokladu trvá moc dlouho. Zkus to za chvíli v Dokladech.");
}
